const FeedbackData = [
  {
    id: 1,
    rating: 10,
    text: 'Your website very nice and clean perfect. 1',
  },
  {
    id: 2,
    rating: 9,
    text: 'Your website very nice and clean perfect. 2',
  },
  {
    id: 3,
    rating: 8,
    text: 'Your website very nice and clean perfect. 3',
  },
  {
    id: 4,
    rating: 7,
    text: 'Your website very nice and clean perfect. 4',
  },
  {
    id: 5,
    rating: 6,
    text: 'Your website very nice and clean perfect. 5',
  },
];

export default FeedbackData;
